<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">修改项目预警时间审批表</h2>
      <a
        href="javascript:;"
        @click="$router.push('/Project/Detail/' + project.id)"
        class="back-btn"
        >返回项目详情</a
      >
    </div>
    <div class="form-content" v-if="project.name">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">
          <create-update-time
            ref="create"
            :project="project"
            :userData="userData"
            :formByFather="form"
          ></create-update-time>

          <!-- <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
            <p class="tip-sm">
              附件:合同条款复印件、工程支付月报表等。
            </p>
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments :projectId="form.projectId" :contractId="form.contractId"  ref="attachments" :type='12'></attachments>
            </el-form-item>
          </div> -->

          <div class="tip" style="margin: 20px 0 0 40px">* 意见与审批</div>
          <div class="clear label-mx">
            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <approval-item
              ref="approval"
              :approvalUsers="approvalUsers.c13"
              :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"
            ></approval-item>
          </div>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button
                :loading="formLoading"
                @click="createUpdate()"
                class="form-btn"
                type="success"
                >确认修改项目预警时间审批</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import approvalUsers from "@/Mixins/approvalUsers";

import ApprovalItem from "@/components/ApprovalItem";
import CreateUpdateTime from "@/page/form/createUpdateTime";

import ObjectUtil from "../mixins/objectUtil";
export default {
  components: {
    ApprovalItem,
    CreateUpdateTime,
  },
  mixins: [approvalUsers, ObjectUtil],
  computed: {
    ...mapState({
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      project: {},
      form: {
        applyId: "",
        projectId: "",
        lxUptime: "",
        sgzbwcsj: "",
        jhkgsj: "",
        jhwgsj: "",
        remark: "",
      },

      // 附件
      // attachments: "",
      // 审批
      approvalType: "0",
      formLoading: false,

      applyInfo: "",
    };
  },
  created() {
    this.form.projectId = this.$route.params.projectId;
    this.getApplyData();
  },
  mounted() {
    this.getProject();
  },
  methods: {
    // 获取审批表原内容
    getApplyData() {
      this.hasApplyId = this.$route.params.applyId ? true : false;
      this.form.applyId = this.$route.params.applyId;
      if (this.form.applyId) {
        this.formLoading = true;
        this.getProjectApplyInfo();
      } else {
        this.getEarlyInfo();
        this.setSelectArr(this.applyInfo, 13);
      }
    },
    // 获取原审批表内容
    getProjectApplyInfo() {
      ajax.get(
        "/gc/project/warntime/apply/info/" + this.form.applyId,
        "",
        (res) => {
          this.applyInfo = res.vo;

          this.form.lxUptime = this.applyInfo.lxUptime;
          this.form.sgzbwcsj = this.applyInfo.sgzbwcsj;
          this.form.jhkgsj = this.applyInfo.jhkgsj;
          this.form.jhwgsj = this.applyInfo.jhwgsj;
          this.form.remark = this.applyInfo.remark;

          this.setSelectArr(this.applyInfo, 13);
          this.formLoading = false;
        }
      );
    },
    // 获取项目已填写过的字段
    getEarlyInfo() {
      ajax.post(
        "/gc/project/early/info/detail",
        {
          projectId: this.form.projectId,
        },
        (res) => {
          this.oldInfo = res.vo;
          let _info = res.vo;
          for (var key in this.form) {
            if (_info[key]) {
              this.form[key] = _info[key];
            }
          }
        }
      );
    },
    // 获取项目
    getProject() {
      ajax.get("/gc/project/detail/" + this.form.projectId, "", (res) => {
        this.project = res.vo;
        // 修改当前选中的侧边栏
        this.setNavType(this.project);
      });
    },
    // 提交申请
    createUpdate() {
      this.form = this.$refs.create.getFromData();
      // if (this.form.underLine == "") {
      //   this.$message.error('请标注本次审批是否已线下通过')
      //   return
      // }

      this.form.approvalType = this.approvalType;
      this.form.approvalUserIds = this.$refs.approval.getUserIds();
      // this.form.attachments = this.$refs.attachments.getAttachments()

      if (!this.form.remark) {
        this.$message.error("修改项目预警时间的修改原因必须填写");
        return;
      }

      this.formLoading = true;
      let _url = !this.form.applyId
        ? "/gc/project/warntime/apply"
        : "/gc/project/warntime/apply/edit";

      ajax.post(
        _url,
        this.form,
        (res) => {
          this.$message.success(
            "提交修改项目预警时间审批成功，请耐心等待领导审批"
          );
          this.$router.push("/Project/Detail/" + this.project.id);
          this.formLoading = false;
        },
        (res) => {
          this.formLoading = false;
        }
      );
    },
  },
  watch: {},
};
</script>


// WEBPACK FOOTER //
// src/page/project/formLayout/createUpdateTime.vue